import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { styled } from '@ori-ui/mui';
import useTestId, { Team, TestIdProvider } from '@ori/testid-generator';
import { APP_NAME } from '../constants-generated';
const Box = styled('div')((param)=>{
    let { theme } = param;
    return {
        backgroundColor: theme.palette.common.white,
        padding: '1em'
    };
});
const Title = styled('h1')((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.primary.main
    };
});
export const LayoutContent = (param)=>{
    let { title, children } = param;
    const { getTestIdProps } = useTestId();
    return /*#__PURE__*/ _jsxs(Box, {
        ...getTestIdProps('layout'),
        children: [
            /*#__PURE__*/ _jsx(Title, {
                children: title
            }),
            children
        ]
    });
};
export const Layout = (param)=>{
    let { title, children } = param;
    return /*#__PURE__*/ _jsx(TestIdProvider, {
        team: Team.Presentation,
        project: APP_NAME,
        children: /*#__PURE__*/ _jsx(LayoutContent, {
            title: title,
            children: children
        })
    });
};
